import { Avatar } from '@/shared/components/Avatar';
import { StatusBadge } from '@/shared/components/StatusBadge';
import { timeAgo } from '@/shared/utils/time';
import type { TrackedResident, ResidentStatus } from '@/shared/firebase/types';

type Props = {
  resident: TrackedResident;
  status: ResidentStatus;
  selected?: boolean;
  onClick?: () => void;
};

export function ResidentCard({ resident, status, selected, onClick }: Props) {
  const name = resident.config?.name || resident.uid;
  const battery = resident.latest?.battery;
  return (
    <button
      onClick={onClick}
      className={`w-full text-left rounded-xl2 border p-3 flex items-center gap-3 transition
        ${selected ? 'border-brand bg-brand-50/50 shadow-soft' : 'border-slate-100 bg-white hover:bg-slate-50'}`}
    >
      <Avatar name={name} photo={resident.config?.photo} />
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <p className="font-semibold text-slate-900 truncate">{name}</p>
          <StatusBadge status={status} />
        </div>
        <p className="text-xs text-slate-500 mt-0.5 truncate">
          {resident.latest ? timeAgo(resident.latest.ts) : 'sin datos'}
          {battery != null && <span className="ml-2">🔋 {Math.round(battery)}%</span>}
        </p>
      </div>
    </button>
  );
}
